import { IntercomState } from "state/types";

export const selectors = {
  getUpdateTs: (state: IntercomState) => state.updateTs,
  getIsBooted: (state: IntercomState) => state.booted,
  getIsPaused: (state: IntercomState) => state.paused,
};
